import { Case } from 'briefpoint-client';
import { useCaseApi } from 'hooks/useApi';
import { useState, useEffect } from 'react';

export default function useCase({ firmId, id }: { firmId?: string; id?: string }) {
  const [caseData, setCase] = useState<Case | undefined>();
  const caseApi = useCaseApi();

  useEffect(() => {
    if (firmId && id) {
      caseApi.caseGet({ firmId, id }).then(setCase);
    }
  }, [caseApi, firmId, id]);

  return { caseData };
}
